import { render, staticRenderFns } from "./orderAddGoodsDialog.vue?vue&type=template&id=283c15de&"
import script from "./orderAddGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./orderAddGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports